const en = {
  plantHalts: {
    navigation: {
      plantHaltsRicSg: 'Plant halts list U2',
    },
  },
}

export default en
